import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d474e67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-map" }
const _hoisted_2 = { class: "title ws_mb20" }
const _hoisted_3 = { id: "map" }

import { ref, onMounted, watch } from 'vue'
import MapDevice from '@/components/map-device'


export default /*#__PURE__*/_defineComponent({
  __name: 'site-map',
  setup(__props, { expose }) {

const mapRef = ref()

const createMaker = ({ longitude, latitude }: any) => {
  mapRef.value.moveMarker({
    lat: latitude,
    lng: longitude,
  })
}

expose({
  createMaker,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('SITE.siteMap')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(MapDevice), {
        ref_key: "mapRef",
        ref: mapRef,
        disabledDoubleClick: true
      }, null, 512)
    ])
  ]))
}
}

})